import { render, staticRenderFns } from "./PricePanelEditForm.vue?vue&type=template&id=d0f1fa4a"
import script from "./PricePanelEditForm.vue?vue&type=script&lang=js"
export * from "./PricePanelEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports